function fnLoadAndPlayVideo(video) {
  if (!video) return;
  
  var dataSrc = video.getAttribute('data-src');
  if (dataSrc && !video.src) {
    video.src = dataSrc;
    video.load();
    video.addEventListener('canplay', function onCanPlay() {
      video.removeEventListener('canplay', onCanPlay);
      video.play().catch(function() {});
    }, { once: true });
  } else {
    video.play().catch(function() {});
  }
}

function fnVerticalSlider(i, oSection) {
  if (window.innerWidth > 860) {
    gsap.context(() => {
      const images = gsap.utils.toArray(".media-slider .item");
      const contentEls = gsap.utils.toArray(".content-slider .item");

      ScrollTrigger.create({
        trigger: ".container",
        pin: true,
        start: () =>
          `top top+=${
            (window.innerHeight -
              oSection.querySelector(".container").offsetHeight) *
            0.5
          }`,
        end: () => "+=" + images.length * window.innerHeight,
        invalidateOnRefresh: true,
      });

      const imagesTl = gsap.timeline({
        ease: "none",
        scrollTrigger: {
          trigger: ".container",
          start: () =>
            `top top+=${
              window.innerHeight -
              oSection.querySelector(".container").offsetHeight
            }`,
          end: () => "+=" + images.length * window.innerHeight,
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });

      const contentTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".container",
          start: () =>
            `top top+=${
              window.innerHeight -
              oSection.querySelector(".container").offsetHeight
            }`,
          end: () => "+=" + images.length * window.innerHeight,
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });

      const contentWrapTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".container",
          start: () =>
            `top top+=${
              window.innerHeight -
              oSection.querySelector(".container").offsetHeight
            }`,
          end: () => "+=" + images.length * window.innerHeight,
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });

      images.map((el, idx) => {
        //if (idx === 0) return;

        if (idx !== 0) {
          imagesTl.to(
            el,
            {
              opacity: 1,
              onComplete: () => {
                const video = el.querySelector("video");
                if (video) {
                  fnLoadAndPlayVideo(video);
                }
              },
            },
            `item-${idx}`
          );
        }

        if (idx != images.length - 1) {
          imagesTl.to(
            el,
            {
              opacity: 0,
              onComplete: () => {
                const video = el.querySelector("video");
                if (video) {
                  video.pause();
                }
              },
            },
            `+=1.5`
          );
        }
      });

      let scrollVal = 0;

      contentEls.map((el, idx) => {
        // Make init state
        /* if (idx === 0) {
          gsap.set(".content-slider .items", {
            y: el.offsetHeight * -0.5,
          });
        } */

        if (idx != 0) {
          contentTl.to(
            el,
            {
              opacity: 0.35,
            },
            `item-${idx - 1}`
          );
        }

        contentTl.to(
          el,
          {
            opacity: 1,
          },
          `item-${idx}`
        );

        if (idx != contentEls.length - 1) {
          contentTl.to(
            el,
            {
              opacity: 0,
            },
            `item-${idx}+=1.5`
          );
        }

        //if (idx !== 0) {
          contentTl.to(
            ".content-slider .items",
            {
              y: () => {
                if (idx === 0) {
                  scrollVal = 0;
                }

                scrollVal += el.offsetHeight * 0.5;

                let retrunVal = scrollVal;

                scrollVal += el.offsetHeight * 0.5 + 40;

                return retrunVal * -1;
              },
            },
            `item-${idx}`
          );
        //}
      });

      // just to add some extra time at the end so the last slide stays put for a bit before becoming unpinned
      imagesTl.to({}, { duration: 0.8 });
      contentWrapTl.to({}, { duration: 0.8 });
      contentTl.to({}, { duration: 0.8 });
    }, oSection);
  } else {
    const toggleVideo = (swiper) => {
      swiper.slides.map((el, idx) => {
        const video = el.querySelector("video");
        if (!video) return;
        if (idx == swiper.realIndex) {
          fnLoadAndPlayVideo(video);
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    };
    new Swiper(oSection.querySelector(".swiper"), {
      spaceBetween: 30,
      navigation: {
        nextEl: oSection.querySelector(".arrows .next"),
        prevEl: oSection.querySelector(".arrows .prev"),
      },
      pagination: {
        el: oSection.querySelector(".progress-bar"),
        type: "progressbar",
      },
      autoplay: {
        delay: 5000,
      },
      on: {
        activeIndexChange: toggleVideo,
        afterInit: toggleVideo,
      },
    });
  }
}
